import SigamAPI from '~/utils/SigamAPI';

export default async function Read({ institutionId }) {
  const response = await SigamAPI({
    url: `/SIGAM/${institutionId}/dashboard/user/totals`,
    method: 'POST',
  });

  return response;
}
